import Image from "next/image"
import wordmark from "@/public/donista-logo.png"
import { cn } from "@/lib/utils"

/**
 * Full "donista" wordmark logo. Uses the established `donista-logo.png` asset
 * (1850×430). Defaults to `h-7 w-auto`; pass `className` to resize.
 */
export default function DonistaWordmark({
  className,
  priority,
}: {
  className?: string
  priority?: boolean
}) {
  return (
    <Image
      src={wordmark}
      alt="donista"
      className={cn("h-7 w-auto", className)}
      priority={priority}
    />
  )
}
